import React, { useState } from "react";

function Faq() {
  // State for which question is open
  const [openFAQ, setOpenFAQ] = useState(null);
  const [openFAQ2, setOpenFAQ2] = useState(null);

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  const toggleFAQ2 = (id) => {
    setOpenFAQ2(openFAQ2 === id ? null : id);
  };

  return (
    <>
      {/* Banner Section */}
      <section className="inner-banner-wrap" style={{ overflowX: "hidden" }}>
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">FAQ</h1>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <div className="faq-page-section">
        <div className="container">
          <div className="faq-page-container">
            <div className="row">
              {/* Left FAQ */}
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="title-divider" />
                  <h2 className="section-title">
                    Frequently Asked <span className="primary-color">Questions</span>
                  </h2>
                  <p>
                    At Codenix Infotech, we provide clarity on our services,
                    innovation, and how we can scale your business effectively.
                  </p>
                </div>

                <div className="accordion-content">
                  {[
                    {
                      id: "A",
                      question: "How we became best among others?",
                      answer:
                        "We focus on innovation, strong engineering, and client-centric delivery to stand out in the IT industry.",
                    },
                    {
                      id: "B",
                      question: "What we offer to you?",
                      answer:
                        "We offer AI solutions, custom web and mobile apps, enterprise software, DevOps, and cloud services.",
                    },
                    {
                      id: "C",
                      question: "How we provide services for you?",
                      answer:
                        "We follow agile methodologies, ensuring regular feedback loops and top-quality deliverables.",
                    },
                    {

                      id: "D",
                      question: "How does the platform leverage AI?",
                      answer: "Our platform uses AI to match users with the most suitable professionals and services, ensuring faster, smarter, and more efficient hiring decisions.",
                    },
                  ].map((faq) => (
                    <div key={faq.id} className="card">
                      <div className="card-header">
                        <h5 className="mb-0">
                          <a
                            className="btn btn-link"
                            onClick={() => toggleFAQ(faq.id)}
                          >
                            {faq.question}
                          </a>
                        </h5>
                      </div>
                      {openFAQ === faq.id && (
                        <div className="card-body">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Contact Form */}
              {/* <div className="col-lg-6">
                <div className="qsn-form-container">
                  <h3>Still have questions?</h3>
                  <p>
                    Contact Codenix Infotech and we’ll help find the right solution for you.
                  </p>
                  <form>
                    <p><input type="text" name="name" placeholder="Your Name*" /></p>
                    <p><input type="email" name="email" placeholder="Your Email*" /></p>
                    <p><input type="text" name="phone" placeholder="Your Phone*" /></p>
                    <p><textarea rows={8} placeholder="Your message" /></p>
                    <p><input type="submit" name="submit" defaultValue="SUBMIT QUESTION" /></p>
                  </form>
                </div>
              </div> */}
            </div>
          </div>

          {/* Second FAQ */}
          <div className="faq-page-container mt-5">
            <div className="row">
              <div className="col-lg-5">
                <div className="faq-testimonial">
                  <figure className="faq-image">
                    <img src="assets/images/img5.jpg" alt="Client Testimonial" />
                  </figure>
                  <div className="testimonial-content">
                    <span className="quote-icon"><i className="fas fa-quote-left" /></span>
                    <p>
                      "Codenix Infotech delivered a world-class AI solution.
                      Their team is highly skilled and reliable."
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="faq-content-wrap">
                  <div className="section-head">
                    <div className="title-divider" />
                    <h2 className="section-title">
                      What We Do & <span className="primary-color">Our Benefits</span>
                    </h2>
                    <p>
                      We empower businesses with innovative software solutions,
                      AI-driven automation, and scalable systems.
                    </p>
                  </div>

                  <div className="accordion-content">
                    {[
                      {
                        id: "E",
                        question: "How Do We Manage Our Clients?",
                        answer:
                          "We provide transparency, regular updates, and agile practices for seamless delivery.",
                      },
                      {
                        id: "F",
                        question: "Are We Providing Best Services For You?",
                        answer:
                          "Yes! We ensure quality through continuous testing, innovation, and customer feedback.",
                      },
                      {
                        id: "G",
                        question: "How We Help You In Best Way?",
                        answer:
                          "We combine AI, cloud, and custom development to create future-ready solutions.",
                      },
                      {
                        id: "H",
                        question: "What We Offer Best For You?",
                        answer:
                          "We deliver innovation, efficiency, and growth-focused solutions to scale your business.",
                      },
                    ].map((faq) => (
                      <div key={faq.id} className="card">
                        <div className="card-header">
                          <h5 className="mb-0">
                            <a
                              className="btn btn-link"
                              onClick={() => toggleFAQ2(faq.id)}
                            >
                              {faq.question}
                            </a>
                          </h5>
                        </div>
                        {openFAQ2 === faq.id && (
                          <div className="card-body">{faq.answer}</div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Faq;
